// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__pYlWR","container":"Landing_container__F95p4"};